export interface EntityImage {
  entity_image_id: string;
  url: string;
  focal_point_x: number;
  focal_point_y: number;
  order: number;
}

export function getPrimaryImage(
  images?: EntityImage[] | null
): EntityImage | null {
  if (!images || images.length === 0) return null;
  return (
    images.find((img) => img.order === 0) ??
    [...images].sort((a, b) => a.order - b.order)[0] ??
    null
  );
}

export function cardImageOf(entity: {
  images?: EntityImage[] | null;
  image?: string | null;
}): { url: string | null | undefined; focalX: number; focalY: number } {
  const primary = getPrimaryImage(entity.images);
  return {
    url: primary?.url ?? entity.image,
    focalX: primary?.focal_point_x ?? 0.5,
    focalY: primary?.focal_point_y ?? 0.5,
  };
}

export function getSortedImages(images: EntityImage[]): EntityImage[] {
  return [...images].sort((a, b) => a.order - b.order);
}

export function focalPointToObjectPosition(
  focalPointX: number,
  focalPointY: number
): string {
  return `${Math.round(focalPointX * 100)}% ${Math.round(focalPointY * 100)}%`;
}
